import { DisposedFormData } from '../types/form/disposedFormData.ts';

interface DisposedFormSlice {
    DisposedFormData: DisposedFormData;
    setDisposedFormData: (data: Partial<DisposedFormData>) => void;
    resetDisposedFormData: () => void;
}

const initialDisposedFormData: DisposedFormData = {
    transactionType: null,
    drug: null,
    storageLocation: null,
    changedQuantity: null,
    remainingQuantityAccordingToUser: null,
    givenQuantity: null,
    disposedQuantity: null,
    administratedDateTime: null,
    description: null,
    medicalRecordId: null,
    patientIdentification: null,
    signature: null,
    doubleSignature: null,
    acceptSaldoMismatch: false,
};

// The slice will manage the state for the disposed form
const createDisposedFormSlice = (set: any) => ({
    disposedFormData: initialDisposedFormData,

    // Set partial data in the disposed form state
    setDisposedFormData: (data: Partial<DisposedFormData>) =>
        set((state: { disposedFormData: DisposedFormData }) => ({
            disposedFormData: { ...state.disposedFormData, ...data },
        })),

    // Reset the entire form data to the initial state
    resetDisposedFormData: () =>
        set({ disposedFormData: initialDisposedFormData }),
});

export { createDisposedFormSlice };
export type { DisposedFormSlice, DisposedFormData };
